export const getMaxAllowedPaymentInAdvance = (totalContractPrice: number): number =>
	totalContractPrice / 2;
